export const KEY_DEV_PORTAL_FORM_STATUS = 'dev-portal-form-done';
